<template>
  <!-- Countdown timer -->
  <div class="inline-flex items-center justify-center text-white text-2xl" :class="blok.style">
    <div class="flex justify-center flex-wrap">
      <div class="w-full text-center tabular-nums">
        {{ days }}
      </div>
      <div class="text-2xs">
        DAYS
      </div>
    </div>
    <div class="self-start">
      :
    </div>
    <div class="flex justify-center flex-wrap">
      <div class="w-full text-center tabular-nums">
        {{ hours }}
      </div>
      <div class="text-2xs">
        HOURS
      </div>
    </div>
    <div class="self-start">
      :
    </div>
    <div class="flex justify-center flex-wrap">
      <div class="w-full text-center tabular-nums">
        {{ minutes }}
      </div>
      <div class="text-2xs">
        MINUTES
      </div>
    </div>
    <div class="self-start">
      :
    </div>
    <div class="flex justify-center flex-wrap">
      <div class="w-full text-center tabular-nums">
        {{ seconds }}
      </div>
      <div class="text-2xs">
        SECONDS
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  blok: {
    type: Object,
    default: null,
  },
})

const days = ref('00')
const hours = ref('00')
const minutes = ref('00')
const seconds = ref('00')

let timer: ReturnType<typeof setInterval> | null = null

const timerEndDate = computed(() => {
  if (props.blok?.end_on_next_quarter) {
    const now = new Date()
    const nextQuarter = new Date(now)
    nextQuarter.setMinutes(Math.ceil(now.getMinutes() / 15) * 15)
    nextQuarter.setSeconds(0)
    nextQuarter.setMilliseconds(0)
    return nextQuarter.getTime()
  }
  else if (props.blok?.end_on_end_of_the_day) {
    const now = new Date()
    const endOfDay = new Date(now)
    endOfDay.setHours(23, 59, 59, 999)
    return endOfDay.getTime()
  }
  else if (props.blok?.end_on_date) {
    return new Date(props.blok.end_on_date).getTime()
  }
  else if (props.blok?.end_in_sec && props.blok.end_in_sec > 0) {
    return new Date().getTime() + props.blok.end_in_sec * 1000
  }
  return null
})

function updateTimer() {
  if (!timerEndDate.value) {
    days.value = hours.value = minutes.value = seconds.value = '00'
    return
  }

  const targetDate = timerEndDate.value
  const now = new Date().getTime()
  const distance = targetDate - now

  if (distance < 0) {
    days.value = hours.value = minutes.value = seconds.value = '00'
    clearInterval(timer!)
    return
  }

  days.value = formatTime(Math.floor(distance / (1000 * 60 * 60 * 24)))
  hours.value = formatTime(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
  minutes.value = formatTime(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)))
  seconds.value = formatTime(Math.floor((distance % (1000 * 60)) / 1000))
}

function formatTime(time: number): string {
  return time < 10 ? `0${time}` : time.toString()
}

onMounted(() => {
  timer = setInterval(updateTimer, 1000)
  updateTimer()
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>
